module.exports = __webpack_public_path__ + "static/AREA83-5b1022a33258778b6663308c754e16a0.jpg";